<template>
  <div>
     <el-dialog title="审核" :visible.sync="shVisible" :close-on-click-modal="false" width="30%" center=""
      @close='closeSH'>
      <el-form :model="shFormData" ref="shFormData" label-width="0px" class="demo-dynamic"
         :rules="shRules">
        <el-form-item prop="changeStatus" label="" :rules="[
          {
            required: true,
            message: '请选择审核结果',
            trigger: 'change'
          }
        ]">
          <el-radio-group v-model="shFormData.changeStatus" @change="RadioChange">
            <el-radio label="1">同意</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-input type="textarea" :rows="3" maxlength="50" placeholder="请输入审核意见"
            v-model="shFormData.approverReject">
          </el-input>
        </el-form-item>
      </el-form>
      <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{ (item.cargoControlKey).replace(/,/g, "/") }}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{ item.sumWeight }}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{ item.num }}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.cargoControlKey != '不控货'">
                  <span style="margin-left:20px;" v-if='item.controlWeight == 1 || item.controlPiece == 1'>未提量：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{ item.controlStockWeight
                    }}</span><span>
                        吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span style="color:red">{{ item.controlStockNumber
                    }}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list" style="width:100%"
            highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="件数" width=""></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="理重（吨）" align="center" width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                  <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
              width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                  <span v-else>{{Number(scope.row.weighingWeight).toFixed(3)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地" width=""></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
            <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width=""></el-table-column>
            <!-- <el-table-column prop="model" align="center" label="出厂过磅净重(吨)"  width=""></el-table-column> -->
          </el-table>
        </div>
      <div style="width: 180px; margin: 15px auto">
        <el-button @click="closeSH">取 消</el-button>
        <el-button type="primary" @click="SHsaveFn" :loading='shenheLoading'>保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import { confirmWhOutstockZyControl } from '@/api/wms-access'
import { virtualControlBeanZy, changeExamineExpZy, getTEmptyChangeDetailList } from '@/api/wms-stock'
export default {
  name: 'AddChukuPlan',
  data () {
    return {
      shVisible: true,
      shenheLoading: false,
      shRules: {
        changeStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        approverReject: [{ required: false, message: '请选择审核结果', trigger: 'change' }]
      },
      shFormData: {
      },
      allDataList: [],
      detailsData: []
    }
  },
  props: {
    ZHshenheVisible: {
      type: Boolean,
      default: false
    },
    zhuData: {
      type: Object
    }
  },
  created () {
    this.getTEmptyChangeDetailListS()
  },
  methods: {
    getTEmptyChangeDetailListS () {
      getTEmptyChangeDetailList(
        {
          changeId: this.zhuData.changeId,
          pageNo: 1,
          pageSize: 1000
        }
      ).then(res => {
        this.detailsData = res.pageInfo.list
        this.detailsData.forEach(item => {
          this.virtualControlBeanZy(item)
        })
      })
        .catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
    },
    // 调用控货接口
    virtualControlBeanZy (xuanzhongJson) {
      virtualControlBeanZy({
        oneCustomerTaxId: this.zhuData.oldPrimaryCustomerId, // （一级货主纳税人识别号  必填）
        twoCustomerTaxId: this.zhuData.oldSecondaryCustomerId, // （二级货主纳税人识别号  必填）
        organizationId: localStorage.getItem('tenantCode'), // （仓储租户id  必填）
        productionPlaceName: xuanzhongJson.steelMillName, // （产地  必填）
        specificationName: xuanzhongJson.specification, // （规格  必填）
        materialName: xuanzhongJson.model, // （材质  必填）
        goodTypeName: xuanzhongJson.productTypeName // （货物类型名称  必填
      }).then(res => {
        console.log(JSON.parse(res), 'res')
        // controlPiece: 1  // 控件  0不控  1控
        // controlWeight: 1 // 控吨  0不控  1控
        // isEnable: 1    //控货不控货标识   1控  2不控
        if (res) {
          let isEnableObj = {}
          isEnableObj = JSON.parse(res)
          // 控货
          if (isEnableObj.isEnable == '1') {
            // let str = `${isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '_'}${isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '_'}${isEnableObj.specificationName ? isEnableObj.specificationName : '_'}${isEnableObj.materialName ? isEnableObj.materialName : ''}`
            let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
              (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
              (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
              (isEnableObj.materialName ? isEnableObj.materialName : '')

            console.log(str, 'str')
            if (str == ',,,') {
              str = '总控'
            }
            if (this.allDataList.some(item => item.cargoControlKey == str)) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
              this.allDataList[index].list.push(xuanzhongJson)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: str,
                releaseFlag: 0,
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: true,
                controlStockWeight: isEnableObj.controlStockWeight,
                controlStockNumber: isEnableObj.controlStockNumber,
                controlWeight: isEnableObj.controlWeight,
                controlPiece: isEnableObj.controlPiece,
                strictReminder: isEnableObj.strictReminder,
                isEnable: isEnableObj.isEnable
              }
              obj.list.push(xuanzhongJson)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          } else {
            // 不控
            if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
              this.allDataList[index].list.push(xuanzhongJson)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: '不控货',
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: false
              }
              obj.list.push(xuanzhongJson)
              this.allDataList.push(obj)
            }
          }
          this.allDataList.forEach((item, index) => {
            this.$set(item, 'num', item.list.reduce((pre, cur) => {
              return pre / 1 + cur.number / 1
            }, 0))
            this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
              return pre / 1 + cur.allWeight / 1
            }, 0)).toFixed(3))
          })
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    RadioChange (val) {
      console.log(val)
      if (val == 2) {
        this.$set(this.shRules.approverReject[0], 'required', true)
      } else {
        this.$set(this.shRules.approverReject[0], 'required', false)
      }
    },
    closeSH () {
      this.$emit('update:ZHshenheVisible', false)
    },
    SHsaveFn () {
      this.$refs.shFormData.validate((valid) => {
        if (valid) {
          debugger
          if (this.shFormData.changeStatus == 2) {
            this.succeshenhe()
          } else {
            this.recursionCheck(0)
          }
        } else {
          this.shenheLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    succeshenhe () {
      this.shenheLoading = true
      let changeQueryZyList = []
      this.allDataList.forEach(item => {
        changeQueryZyList.push({
          productionPlaceName: item.list[0].specification,
          goodTypeName: item.list[0].productTypeName,
          specificationName: item.list[0].specification,
          materialNa: item.list[0].model,
          cargoControlFalg: item.isEnable,
          controlWeight: item.controlWeight,
          controlPiece: item.controlPiece,
          releaseFlag: item.releaseFlag,
          changeWeight: item.sumWeight,
          changeNumber: item.num
        })
      })
      changeExamineExpZy(
        {
          changeId: this.zhuData.changeId,
          changeQueryZyList: changeQueryZyList,
          ...this.shFormData
        }
      )
        .then(res => {
          console.log(res)
          this.shenheLoading = false
          this.shVisible = false
          DonMessage.success('审核成功')

          this.$parent.getTEmptyChangeMasterLists()
        })
        .catch(err => {
          this.shenheLoading = false
          this.$message(
            {
              message: err.message,
              type: 'error'
            }
          )
        })
    },
    recursionCheck (index, type) {
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.succeshenhe()
        return
      }
      if (index > this.allDataList.length) {
        return
      }
      const item = this.allDataList[index]
      console.log(item, 'item')
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          // 控件
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量')
              return
            }
          }
          this.recursionCheck(index + 1, type)
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          // let conFlag = true
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else {
            this.recursionCheck(index + 1, type)
          }
        }
      } else {
        this.succeshenhe()
      }
      // }
    }
  }
}
</script>

<style>

</style>
